export const DEFAULT_MARKS = {
  ALL: 'all',
  DONE: 'done',
  UNREAD: 'unread',
  REQUEST: 'request',
  IMPORTANT: 'important',
};
